import { connect } from 'react-redux'
import { setLayoutModalInfo } from 'core/templates/actions'
import Header from './Header'

const mapStateToProps = state => ({
  configuration: state.configuration,
  vehicle: state.layout.vehicle,
  tradeIn: state.layout.tradeIn
})

const mapDispatchToProps = { setLayoutModalInfo }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header)
